/** Neutral lazy-composition contract for separately deployable public portal hosts. */
export const platformPortalHostCapability = 'platform.portal-host.v1';
//# sourceMappingURL=platform-portal-host.contract.js.map